import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';
import { getDataById, getImage } from './utils';

export function UserBadge({ userId, type = 'md' }) {
  const context = useContext(Context);
  let user = getDataById(context, 'users', userId)
  return (
    <>
      {type === 'md' && user && <div className="x_user0">
        <div className="x_user_ava">
          <img src={getImage(user['img'])} loading="lazy" className="p_user_ava_img p_user_ava_img--sm" />
        </div>
        <h5 className="x_user_name">
          <span>
            <strong>{user['name']} {user['nameLast']}</strong>
          </span>
        </h5>
      </div>}

      {type === 'sm' && user && <div className="ui_video_author">
        <div className="x_user_ava">
          <img
            src={getImage(user['img'])}
            loading="lazy"
            className="p_user_ava_img p_user_ava_img--sm"
          />
        </div>
        <div className="x_user_name">
          <strong>{user['name']} {user['nameLast']}</strong>
        </div>
      </div>}

    </>
  )
}